import $ from 'jquery';

Drupal.behaviors.banner = {
  attach(context) {
        if (document.querySelector('.type-4') !== null && document.querySelector('.node-landing-page-layout-builder-form') == null ) {
          $(".overlay-banner").show();
        }
        $('.cancel-banner-popup').on('click',function(){
          $(".type-4").hide();
          $(".overlay-banner").hide();
        });
        $(".layout-builder__add-block").hover(function() {
          $( ".cta-banner-containerwidth-wrapper :button" ).removeClass( "visually-hidden" );
        });
        $(".type-4 a").on('click',function(){
          $(".type-4").hide();
          $(".overlay-banner").hide();
        })
         
  },
};
